
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class ChaseTransactionLogsService {
    private baseUrl: string;
    
    constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
        //this.baseUrl = environment.Invoiceservicebaseurl;
        this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
    }

    // Method to get the Chase Transaction Logs
    GetChaseTransactionLogs(): Observable<any[]> {
        return this.http.get<any[]>(this.baseUrl + `/api/GetChaseTransactionLogs`).pipe(
            map(response => response),
            catchError(handleError),);
    }
}

function handleError(error: any) {
    // log error
    // could be something more sofisticated
    let errorMsg = error.message || ``;
    console.error(errorMsg);

    // throw an application level error
    return observableThrowError(errorMsg);
}